<script>
    import Portability from './Portability.svelte';
    import { lineProps } from '../../data/lineProps';
    export let title;
    export let plans;
    export let showLines = false;

    let MXNCurrency = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 0,
    });

    let isPrincipal = !plans[0].plan.extra;
    let isVisibleDescription = false;
    let { subtitle, cost, precioSP, description } = isPrincipal
        ? plans[0].plan
        : plans[0].plan.extra;

    const costValue = precioSP > 0 ? precioSP : cost;

    plans.forEach((item, index) => {
        item.index = index + 1;
    });

    let showIndex = 1;
    let progress = 0.0;
    $: progress = (showIndex / plans.length) * 100;

    const printPrice = (costValue, plans) => {
        let timesToMultiply = 0;
        timesToMultiply += plans.filter(
            (plan) =>
                lineProps.filter((line) => plan.title === line.title)[0]
                    ?.shouldCountInTotal ?? true
        ).length;
        return MXNCurrency.format(costValue * timesToMultiply);
    };

    const printLineaName = (plan) => {
        if (
            lineProps.filter((line) => plan.title === line.title)[0]
                ?.shouldShowPersonalizedName ??
            false
        ) {
            return plan.index === 1
                ? 'principal'
                : 'adicional ' + (plan.index - 1);
        }
        return plan.index;
    };

    const toggleShowLines = (event) => {
        event.stopPropagation();
        showLines = !showLines;
    };

    const detailHandler = (event) => {
        event.stopPropagation();
        isVisibleDescription = !isVisibleDescription;
    };

    $: progressWidth = (showIndex / plans.length) * 100;
</script>

<div class="panel panel--no-mobile m-b-20">
    <a
        href="#/"
        class="pure-g back-link justify-content-between"
        on:click|preventDefault={toggleShowLines}
    >
        <div class="m-b-5">
            <div class="d-flex plan-details">
                <img
                    class="sim-icon"
                    src="/assets/img/content/izzi-movil-sim.png"
                    alt=""
                />
                <article class="details">
                    <span class="title text-fs-20 fw-semibold">{title}</span>
                    <span>
                        <button
                            type="button"
                            on:click|preventDefault={detailHandler}
                            class="primary-text"
                        >
                            {!isVisibleDescription ? 'Conoce más' : 'Ocultar'}
                        </button>
                    </span>
                    <span
                        class="plan-description {isVisibleDescription
                            ? ''
                            : 'hide'}"
                        >{isPrincipal ? description : subtitle}</span
                    >
                </article>
            </div>
        </div>
        <div>
            <div class="d-flex align-items-center justify-content-end">
                <span class="text-fs-18"
                    ><span class="primary-text fw-semibold"
                        >{printPrice(costValue, plans)}</span
                    > al mes</span
                >
                <svg
                    class="m-l-15 icon"
                    aria-hidden="true"
                    style="transform: rotate({showLines ? '' : '-'}90deg);"
                >
                    <use
                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                    ></use>
                </svg>
            </div>
        </div>
    </a>
    <hr />
    <div class="pure-g">
        <div class="pure-u-1">
            <div
                class={showLines
                    ? 'pure-g align-items-center justify-content-arround'
                    : ''}
            >
                {#each plans as plan}
                    {#if !showLines}
                        <p>
                            <span class="fw-semibold">
                                Línea {printLineaName(plan)}
                            </span>
                            <br />
                            Portabilidad:
                            <span class="aqua-text fw-semibold"
                                >{plan.portability === 'Y' ? 'con' : 'sin'} portabilidad</span
                            >
                        </p>
                    {:else}
                        <div
                            class="text-center"
                            style="width: {100 / plans.length}% !important;"
                        >
                            <button
                                on:click|preventDefault={() => {
                                    showIndex = plan.index;
                                }}
                                class="progress-step {plan.index < showIndex
                                    ? 'progress-step--complete'
                                    : plan.index === showIndex
                                      ? 'progress-step--active'
                                      : ''}
                                                "
                                style="margin-left: 10px !important;"
                            >
                                <span class="step-num">
                                    {#if plan.index < showIndex}
                                        <span class="check">
                                            <img
                                                src="/assets/img/icons/check-dark.svg"
                                                alt=""
                                                aria-hidden="true"
                                            />
                                        </span>
                                    {:else}
                                        <span class="num">{plan.index}</span>
                                    {/if}
                                </span>
                                <span class="step-text">Línea {plan.index}</span
                                >
                            </button>
                        </div>
                    {/if}
                {/each}
            </div>
            {#if showLines}
                <div class="m-t-20">
                    <div class="progress-bar-holder">
                        <div class="progress-bar"></div>
                        <div
                            class="progress-indicator"
                            style="width: {progressWidth}%"
                        ></div>
                    </div>
                </div>
            {/if}
        </div>
        <div class="pure-u-1 m-t-20" class:hide={!showLines}>
            {#each plans as item}
                <div
                    id="linea_{item.plan.extId}_{item.index}"
                    class="payment-tab-content {item.index === showIndex
                        ? ''
                        : 'hide'}"
                >
                    <Portability bind:item />
                    <div class="py-15">
                        <p class="text-fs-15">
                            <span class="fw-semibold">Nota:</span> Recuerda que
                            puedes realizar la portabilidad llamando al
                            <span class="fw-bold">800 120 5000</span> en cualquier
                            momento.
                        </p>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .sim-icon {
        min-width: 80px;
        height: 52.83px;
    }

    .panel {
        display: flex;
        padding: 20px 27px 20px 39px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }

    .details {
        display: flex;
        flex-direction: column;
        padding: 0 1em;
    }

    .plan-details {
        max-width: 700px;
    }

    .hide {
        display: none;
    }

    hr {
        width: 100%;
        padding: 0;
    }

    .back-link {
        padding: 1rem;
    }

    .back-link:hover,
    .back-link:focus {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        border-radius: 10px;
    }
</style>
